import * as React from 'react';
import { memo } from 'react';
import Note from './Note';
import theme from './ImageView.module.scss';
import cn from 'classnames';
import { combineReader } from '@devexperts/utils/dist/adt/reader.utils';
export var ImageView = combineReader(Note, function (NoteComponent) {
    return memo(function (_a) {
        var saveResult = _a.saveResult, noteNumber = _a.noteNumber, onCancel = _a.onCancel, teamMembers = _a.teamMembers, onSave = _a.onSave, hidden = _a.hidden, pos = _a.pos, onPositionChange = _a.onPositionChange, nameField = _a.nameField, rect = _a.rect;
        return (React.createElement("div", { className: cn(theme.container, hidden && theme.container_hidden) },
            React.createElement(NoteComponent, { onPositionChange: onPositionChange, saveResult: saveResult, pos: pos, onCancel: onCancel, onSave: onSave, teamMembers: teamMembers, number: noteNumber, nameField: nameField, rect: rect })));
    });
});
//# sourceMappingURL=ImageView.js.map